module.exports = __webpack_public_path__ + "ddd298e61477dd96d526c64b5dbd0b04.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/images/pillar-corrias-gallery.gif
 ** module id = 390
 ** module chunks = 0
 **/